var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    encoding: "utf-8",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@import url(icons.css);")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M50 8l-36 21v21l36 21 36 -21v-21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M50 71l-36 -21v21l36 21 36 -21v-21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M50 50l36 -21 M14 29l36 21 M50 92v-42 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevels);
export default __webpack_public_path__ + "static/media/levels.65603f067ce730966d690ced142fc2d4.svg";
export { ForwardRef as ReactComponent };